import React from "react";
import { withStyles } from "@material-ui/core";
import { omit } from "@bonliva-crm/common";
import KeyboardReturnIcon from "@material-ui/icons/KeyboardReturn";
import { TicketEventFragment as EventData } from "@graphql";
import { Classes, ThemeType } from "@theme";
import { Paragraph } from "@components/typography/Paragraph";
import Highlighter from "@components/Highlighter";
import { Event } from "../../Event/Event";

type Props = {
  classes: Classes<typeof styles>;
  item: EventData;
  search?: string | RegExp;
};

class TicketLogEvent extends React.Component<Props> {
  render() {
    const { item, search } = this.props;

    return (
      <Event
        key={this.props.item._id}
        icon={<KeyboardReturnIcon />}
        {...omit(this.props, "classes")}
      >
        <Paragraph>
          <Highlighter nl2br search={search}>
            {item.Description}
          </Highlighter>
        </Paragraph>
      </Event>
    );
  }
}

const styles = (theme: ThemeType) => ({});

export default withStyles(styles as any)(TicketLogEvent);
